export const ACCEPTED_FILE_TYPES = {
  // Images (handled as image attachments, not documents)
  'image/png': ['.png'],
  'image/jpeg': ['.jpeg', '.jpg'],

  // PDF
  'application/pdf': ['.pdf'],

  // Microsoft Office
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],

  // Plain text / markup
  'text/plain': [
    '.txt',
    '.py', '.js', '.ts', '.jsx', '.tsx', '.java', '.c', '.cpp', '.cs',
    '.rb', '.go', '.php', '.rs', '.swift', '.kt', '.m', '.scala',
    '.sh', '.pl', '.lua', '.r', '.dart',
    '.html', '.css', '.json', '.xml', '.yml', '.yaml', '.sql', '.svg',
  ],
  'text/markdown': ['.md'],
  'text/csv': ['.csv'],

  // Rich / open formats
  'application/rtf': ['.rtf'],
  'application/vnd.oasis.opendocument.text': ['.odt'],
  'application/vnd.oasis.opendocument.spreadsheet': ['.ods'],
  'application/vnd.oasis.opendocument.presentation': ['.odp'],
  'application/vnd.apple.pages': ['.pages'],
  'application/x-abiword': ['.abw'],

  // Google Workspace (exported by Drive)
  'application/vnd.google-apps.document': [],
  'application/vnd.google-apps.spreadsheet': [],
  'application/vnd.google-apps.presentation': [],
};

export const SPACE_FILE_TYPES = {
  'application/pdf': ['.pdf'],
  'text/plain': ['.txt', '.svg'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
};
